import { AxiosInstance } from 'axios';
import { IQuotePaymentTermCodeData } from '@/models';
import { IQuotePaymentTermCodeService } from './quote-payment-term-code.types';

export class QuotePaymentTermCodeService
  implements IQuotePaymentTermCodeService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/quotes/templates/payment-terms/codes/';
  }

  fetchQuotePaymentTermCodes(): Promise<IQuotePaymentTermCodeData[]> {
    return this.axios.get(`${this.endpoint}`).then(({ data }) => data);
  }

  fetchQuotePaymentTermCode(id: number): Promise<IQuotePaymentTermCodeData> {
    return this.axios.get(`${this.endpoint}${id}/`).then(({ data }) => data);
  }
}
